import { from, of } from "rxjs"
import { ofType } from "redux-observable"
import { switchMap, catchError } from "rxjs/operators"
import { push } from "connected-react-router"

import {
    fetchUserViewDetailsSuccess,
    saveUserViewDetailsSuccess,
    createOrUpdateStatus,
    updateUserViewDetailsSuccess,
    toggleViewMangerNotification,
} from "./actions"
import { hideLoader } from "../loader/actions"
import { labels } from "../../constants/labels"

import * as errorActions from "../error/actions"
import { showNotification } from "../notification/actions"

import viewsApi from "../../api/user-views-api"
import * as types from "./actionTypes"

export function fetchUserViewDetailsTest(action$) {
    return action$.pipe(
        ofType(types.USER_VIEWS_DETAILS_FETCH),
        switchMap(() =>
            from(viewsApi.getUserViews()).pipe(
                switchMap((data) => of(fetchUserViewDetailsSuccess(data))),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function deleteUserViewDetails(action$) {
    return action$.pipe(
        ofType(types.USER_VIEWS_DELETE),
        switchMap((action) =>
            from(viewsApi.deleteUserView(action.payload)).pipe(
                switchMap(() =>
                    of(
                        {
                            type: types.USER_VIEWS_DETAILS_FETCH,
                        },
                        toggleViewMangerNotification({
                            status: "success",
                            show: true,
                            message: `${labels.viewsLbl.view} "${action.payload.name}" ${labels.viewsLbl.successfullyDeleted}`,
                        })
                    )
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function saveUserViewDetails(action$) {
    return action$.pipe(
        ofType(types.USER_VIEWS_SAVE),
        switchMap((action) =>
            from(viewsApi.saveUserView(action.payload)).pipe(
                switchMap((data) =>
                    of(
                        saveUserViewDetailsSuccess(data),
                        createOrUpdateStatus(true),
                        showNotification({
                            show: true,
                            message: `${labels.viewsLbl.view} "${data.name}" ${labels.viewsLbl.successfullyCreated}`,
                            alertType: "success",
                        })
                    )
                ),
                catchError((error) => {
                    if (error?.status === 429) {
                        const rateLimitMessage =
                            labels.viewsLbl.publicViewsThresholdExceeded

                        return of(
                            showNotification({
                                show: true,
                                message: rateLimitMessage,
                                alertType: "error",
                            })
                        )
                    }

                    return of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                })
            )
        )
    )
}

export function updateUserViewDetails(action$) {
    return action$.pipe(
        ofType(types.USER_VIEWS_UPDATE),
        switchMap((action) =>
            from(viewsApi.updateUserView(action.payload)).pipe(
                switchMap((data) =>
                    of(
                        {
                            type: types.USER_VIEWS_DETAILS_FETCH,
                        },
                        updateUserViewDetailsSuccess(data),
                        createOrUpdateStatus(true),
                        action.isManageViewModal
                            ? toggleViewMangerNotification({
                                  status: "success",
                                  show: true,
                                  message: `${labels.viewsLbl.view} "${data.name}" ${labels.viewsLbl.successfullyUpdated}`,
                              })
                            : showNotification({
                                  show: true,
                                  message: `${labels.viewsLbl.view} "${data.name}" ${labels.viewsLbl.successfullyUpdated}`,
                                  alertType: "success",
                              })
                    )
                ),
                catchError((error) => {
                    if (error?.status === 429) {
                        const rateLimitMessage =
                            labels.viewsLbl.publicViewsThresholdExceeded

                        return of(
                            showNotification({
                                show: true,
                                message: rateLimitMessage,
                                alertType: "error",
                            })
                        )
                    }

                    return of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                })
            )
        )
    )
}
